var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightcircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05462 14.8078L19.8516 14.5658",
    stroke: "#FB7C51",
    strokeWidth: 1.71266,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6263 9.85595C16.7665 10.4915 17.7228 11.2984 18.6249 12.242C19.0538 12.6908 19.5964 13.0966 19.9806 13.574C20.1194 13.7464 21.1622 14.8984 21.0955 15.1514C21.0711 15.2442 20.7691 15.3805 20.714 15.4208C20.3953 15.6537 20.1094 15.9285 19.7985 16.1717C19.2288 16.6176 18.7276 17.1247 18.1536 17.5652C17.6429 17.9571 17.2044 18.434 16.6781 18.8088C16.4539 18.9685 16.1875 19.184 16.1055 19.4481",
    stroke: "#FB7C51",
    strokeWidth: 1.71266,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2842,
    cy: 14.2841,
    r: 13,
    transform: "rotate(88.825 14.2842 14.2841)",
    stroke: "#FB7C51",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightcircleIcon);
export default __webpack_public_path__ + "static/media/rightcircleIcon.3026389a2cd867f569766d20471b86a0.svg";
export { ForwardRef as ReactComponent };